import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import moment from 'moment'
import { useTranslate } from 'react-admin'

const format = process.env.REACT_APP_DATEFORMAT ?? 'DD/MM/YYYY'

const useStyles = makeStyles((theme) => ({
  field: {
    ...theme.mundi.font.roboto400Normal,
    whiteSpace: 'nowrap',
    fontSize: '13px',
    lineHeight: '15.23px',
  },
}))

export const CreditLineStatusDescriptionField = ({
  source,
  record,
  basePath,
  ...props
}) => {
  const classes = useStyles()
  const translate = useTranslate()
  return (
    <Typography {...props}>
      {record[source] === 'active' && (
        <>
          <span className={classes.field}>
            {translate('resources.creditlines.messages.openedOn').replace(
              '<<openedOn>>',
              moment.utc(record.openedOn).format(format)
            )}
          </span>
        </>
      )}
    </Typography>
  )
}
